import _isFunction from "lodash/isFunction";
import strings from "web/script/utils/strings";
import "web/script/components/auto-complete";

var SEARCH_INPUT_SELECTOR = 'input[name="q"]';
var USER_SEARCH_TERM_INPUT_SELECTOR = 'input[name="term"]';

/**
 * The autosuggest mixin - wraps the search input and autosuggest.
 */
export default {
    // TODO require template?

    tagName: "form",

    setupEvents: function(add) {
        add("focus", SEARCH_INPUT_SELECTOR, this.onFocus);
        add("input", SEARCH_INPUT_SELECTOR, this.onInput);
        add("keydown", SEARCH_INPUT_SELECTOR, this.onKeyDown);
        add("submit", this.onSubmit);
        add("suggestionSelect", "auto-complete", this.onSuggestionSelect);
    },

    init() {
        // TODO make sure this works
        ["getCurrentGender", "onFocus", "onGlobalClick", "onSuggestionSelect"].forEach(
            function(methodName) {
                if (!_isFunction(this[methodName])) {
                    throw new Error(
                        "The component " +
                            this.name +
                            " has not implemented the method " +
                            methodName +
                            " which is required by the overlay-mixin."
                    );
                }
            }.bind(this)
        );
    },

    /**
     * When the component is removed we can release all global handlers that may have been set.
     */
    onRemove() {
        // TODO Mixin
        this.releaseAllGlobalHandlers();
    },

    /**
     * Keydown event handler
     * @param {Event} event
     */
    onKeyDown(event) {
        // TODO Mixin
        switch (event.keyCode) {
            // up key
            case 38:
                event.preventDefault();
                this._updateAutoComplete("prev");
                break;

            // down key
            case 40:
                event.preventDefault();
                this._updateAutoComplete("next");
                break;

            // tab key
            case 9:
                event.preventDefault();
                this._updateAutoComplete(event.shiftKey === true ? "prev" : "next");
                break;
        }
    },

    /**
     * Handles the 'input' event on the search query input. Makes sure the auto-complete knows
     * the current search query and save the current query in the hidden "term" input.
     */
    onInput(e) {
        // Setting the placeholder attribute on an input field will fire the input event on IE
        // e.g. app-header-search.js - onMenuGenderChange()
        // We only want to run this function if the search field has focus
        if (e && document.activeElement != e.target) return;
        var query = this.getSearchQuery();

        var autoComplete = this._getAutoComplete();
        autoComplete.updateOptions({
            query: query,
            gender: this.getCurrentGender(),
        });
        this._showAutoComplete();

        this.setSearchTerm(query);
    },

    /**
     * Public method for focusing the search query input.
     */
    focus() {
        // TODO Mixin
        this._getInput().focus();
    },

    /**
     * Public method for bluring the search query input.
     */
    blur() {
        // TODO Mixin
        this._getInput().blur();
    },

    /**
     * Uses stripHTML to prevent XSS attack on search query
     * @return {string} The current search query.
     */
    getSearchQuery() {
        // TODO Mixin
        return strings.stripHTML(this._getInput().value.trim());
    },

    /**
     * @param {string|null} text
     */
    setSearchQuery(text) {
        // TODO Mixin
        this._getInput().value = text;
    },

    /**
     * Get the last user inputted search term (what the user typed)
     */
    getSearchTerm() {
        // TODO Mixin
        return this.el.querySelector(USER_SEARCH_TERM_INPUT_SELECTOR).value;
    },

    /**
     * Set a hidden input to have the last term the user typed
     */
    setSearchTerm: function(term) {
        this.el.querySelector(USER_SEARCH_TERM_INPUT_SELECTOR).value = term;
    },

    /**
     * Updates the auto-complete's active suggestion, moving in `direction`.
     * @param {string} direction Either 'prev' or 'next'
     * @private
     */
    _updateAutoComplete(direction) {
        var autoComplete = this._getAutoComplete();
        var activeSuggestion = autoComplete.getActiveSuggestion();
        var methods = {
            prev: ["selectPrevious", "selectLast"],
            next: ["selectNext", "selectFirst"],
        };
        var method = methods[direction][activeSuggestion === null ? 1 : 0];

        // Make sure the auto-complete component is visible and call the appropriate method
        activeSuggestion = autoComplete[method]();
        this._showAutoComplete();
        this.setSearchQuery(this._getQueryFromSuggestion(activeSuggestion));
    },

    _getAutoComplete() {
        return this.findComponent("auto-complete");
    },

    // These two methods below probably won't be neccessary once new auto-complete component exists
    _showAutoComplete() {
        this._getAutoComplete().show();
    },

    _hideAutoComplete() {
        this._getAutoComplete().hide();
    },

    /**
     * @returns {HTMLElement}
     * @private
     */
    _getInput() {
        // TODO Mixin
        return this.el.querySelector(SEARCH_INPUT_SELECTOR);
    },

    /**
     * Given a suggestion, returns the correct input value to be shown to the user.
     * Handles what to do for the different types of suggestions
     * @param suggestionObject
     * @returns {String} The input value to be show to the user for the passed suggestion
     * @private
     */
    _getQueryFromSuggestion(suggestionObject) {
        // TODO Mixin
        if (suggestionObject && suggestionObject.suggestion.type === "query") {
            // the query may contain HTML so we need to strip that out
            return strings.stripHTML(suggestionObject.suggestion.query);
        }
        return this.getSearchTerm();
    },
};
